import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, vShow as _vShow } from "vue";
const _hoisted_1 = {
  class: "modalHeader"
};
const _hoisted_2 = {
  class: "headerLeft"
};
const _hoisted_3 = {
  class: "headerTitles"
};
const _hoisted_4 = {
  class: "modalTitle"
};
const _hoisted_5 = {
  class: "modalSubtitle"
};
const _hoisted_6 = {
  class: "translationManagementModal"
};
const _hoisted_7 = {
  key: 0,
  class: "missingTranslationsBanner"
};
const _hoisted_8 = {
  class: "bannerLeft"
};
const _hoisted_9 = {
  class: "bannerText"
};
const _hoisted_10 = {
  class: "filterBar"
};
const _hoisted_11 = {
  class: "filterLine"
};
const _hoisted_12 = {
  class: "filterFieldsFullWidth"
};
const _hoisted_13 = {
  class: "filterField"
};
const _hoisted_14 = {
  class: "titleFilter"
};
const _hoisted_15 = {
  class: "filterField"
};
const _hoisted_16 = {
  class: "titleFilter"
};
const _hoisted_17 = {
  class: "filterField"
};
const _hoisted_18 = {
  class: "titleFilter"
};
const _hoisted_19 = {
  key: 1,
  class: "translationCountAndLang"
};
const _hoisted_20 = {
  class: "translationCount"
};
const _hoisted_21 = {
  class: "rightControls"
};
const _hoisted_22 = {
  class: "languageSelector"
};
const _hoisted_23 = {
  class: "translationContent"
};
const _hoisted_24 = {
  key: 0,
  class: "translationList"
};
const _hoisted_25 = ["onClick"];
const _hoisted_26 = {
  class: "accordionTitle"
};
const _hoisted_27 = {
  class: "accordionCount"
};
const _hoisted_28 = {
  class: "accordionMissing"
};
const _hoisted_29 = {
  class: "accordionProgressBar"
};
const _hoisted_30 = {
  class: "accordionPercent"
};
const _hoisted_31 = {
  class: "accordionBody"
};
const _hoisted_32 = {
  class: "groupHeader"
};
const _hoisted_33 = {
  class: "groupIndex"
};
const _hoisted_34 = {
  class: "headerBadge"
};
const _hoisted_35 = {
  class: "groupLabel"
};
const _hoisted_36 = {
  class: "groupRows"
};
const _hoisted_37 = {
  class: "langRow originalRow"
};
const _hoisted_38 = {
  class: "langLabel"
};
const _hoisted_39 = {
  class: "targetContent"
};
const _hoisted_40 = {
  class: "targetContentWrapper"
};
const _hoisted_41 = {
  key: 0,
  class: "imageUploadContainer sourcePreview"
};
const _hoisted_42 = {
  class: "imagePreview"
};
const _hoisted_43 = ["src"];
const _hoisted_44 = {
  key: 1,
  class: "imageUploadContainer fileUploadContainer sourcePreview"
};
const _hoisted_45 = ["innerHTML"];
const _hoisted_46 = {
  class: "targetContent"
};
const _hoisted_47 = {
  class: "targetContentWrapper"
};
const _hoisted_48 = {
  key: 0,
  class: "textAreaWithAi richKeyRow"
};
const _hoisted_49 = {
  key: 0
};
const _hoisted_50 = {
  key: 1,
  class: "richKeyEmpty"
};
const _hoisted_51 = {
  key: 0,
  class: "aiCellLoader"
};
const _hoisted_52 = {
  key: 1,
  class: "textAreaWithAi"
};
const _hoisted_53 = ["onUpdate:modelValue", "onBlur"];
const _hoisted_54 = {
  key: 0,
  class: "aiCellLoader"
};
const _hoisted_55 = ["onDragenter", "onDrop"];
const _hoisted_56 = {
  key: 0,
  class: "imagePreview"
};
const _hoisted_57 = ["src"];
const _hoisted_58 = ["onClick"];
const _hoisted_59 = {
  key: 0,
  class: "imagePreview"
};
const _hoisted_60 = ["src"];
const _hoisted_61 = ["onClick"];
const _hoisted_62 = ["id", "onChange"];
const _hoisted_63 = ["onDragenter", "onDrop"];
const _hoisted_64 = ["onClick"];
const _hoisted_65 = ["id", "onChange"];
const _hoisted_66 = {
  key: 4,
  class: "textAreaWithAi"
};
const _hoisted_67 = ["onUpdate:modelValue", "onBlur"];
const _hoisted_68 = {
  key: 0,
  class: "aiCellLoader"
};
const _hoisted_69 = ["onClick"];
const _hoisted_70 = {
  class: "accordionTitle"
};
const _hoisted_71 = {
  class: "accordionCount"
};
const _hoisted_72 = {
  class: "accordionMissing"
};
const _hoisted_73 = {
  class: "accordionProgressBar"
};
const _hoisted_74 = {
  class: "accordionPercent"
};
const _hoisted_75 = {
  class: "accordionBody"
};
const _hoisted_76 = {
  class: "groupHeader"
};
const _hoisted_77 = {
  class: "groupIndex"
};
const _hoisted_78 = {
  class: "headerBadge"
};
const _hoisted_79 = {
  class: "groupLabel"
};
const _hoisted_80 = {
  class: "groupRows"
};
const _hoisted_81 = {
  class: "langRow originalRow"
};
const _hoisted_82 = {
  class: "langLabel"
};
const _hoisted_83 = {
  class: "targetContent"
};
const _hoisted_84 = {
  class: "targetContentWrapper"
};
const _hoisted_85 = {
  key: 0,
  class: "imageUploadContainer sourcePreview"
};
const _hoisted_86 = {
  class: "imagePreview"
};
const _hoisted_87 = ["src"];
const _hoisted_88 = {
  key: 1,
  class: "imageUploadContainer fileUploadContainer sourcePreview"
};
const _hoisted_89 = ["innerHTML"];
const _hoisted_90 = {
  class: "targetContent"
};
const _hoisted_91 = {
  class: "targetContentWrapper"
};
const _hoisted_92 = {
  key: 0,
  class: "textAreaWithAi richKeyRow"
};
const _hoisted_93 = {
  key: 0
};
const _hoisted_94 = {
  key: 1,
  class: "richKeyEmpty"
};
const _hoisted_95 = {
  key: 0,
  class: "aiCellLoader"
};
const _hoisted_96 = {
  key: 1,
  class: "textAreaWithAi"
};
const _hoisted_97 = ["onUpdate:modelValue", "onBlur"];
const _hoisted_98 = {
  key: 0,
  class: "aiCellLoader"
};
const _hoisted_99 = ["onDragenter", "onDrop"];
const _hoisted_100 = {
  key: 0,
  class: "imagePreview"
};
const _hoisted_101 = ["src"];
const _hoisted_102 = ["onClick"];
const _hoisted_103 = {
  key: 0,
  class: "imagePreview"
};
const _hoisted_104 = ["src"];
const _hoisted_105 = ["onClick"];
const _hoisted_106 = ["id", "onChange"];
const _hoisted_107 = ["onDragenter", "onDrop"];
const _hoisted_108 = ["onClick"];
const _hoisted_109 = ["id", "onChange"];
const _hoisted_110 = {
  key: 4,
  class: "textAreaWithAi"
};
const _hoisted_111 = ["onUpdate:modelValue", "onBlur"];
const _hoisted_112 = {
  key: 0,
  class: "aiCellLoader"
};
const _hoisted_113 = {
  key: 0,
  class: "noData"
};
const _hoisted_114 = {
  key: 1,
  class: "modalLoader"
};
const _hoisted_115 = {
  class: "modalFooter"
};
const _hoisted_116 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_w_input = _resolveComponent("w-input");
  const _component_w_select = _resolveComponent("w-select");
  const _component_loader = _resolveComponent("loader");
  const _component_icon_button = _resolveComponent("icon-button");
  const _component_confirm_dialog = _resolveComponent("confirm-dialog");
  const _component_speach_html_translation_dialog = _resolveComponent("speach-html-translation-dialog");
  const _component_speach_diagram_translation_dialog = _resolveComponent("speach-diagram-translation-dialog");
  const _component_w_pdf_viewer_dialog = _resolveComponent("w-pdf-viewer-dialog");
  const _component_w_dialog = _resolveComponent("w-dialog");
  return _openBlock(), _createBlock(_component_w_dialog, {
    visible: _ctx.visible,
    fullscreen: true,
    "append-to-body": true,
    "custom-class": 'backgroundOverlayEditingTranslation',
    closeOnOutsideClick: false
  }, {
    header: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('speachTranslation.manage.modalTitle')), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.speachTitle), 1)])])])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [!_ctx.loading && _ctx.hasMissingTranslations ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_icon, {
      icon: "alert-outline",
      class: "bannerIcon"
    }), _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('speachTranslation.manage.missingBanner')), 1)]), _createVNode(_component_standard_button, {
      class: "bannerButton",
      outlined: true,
      label: _ctx.$t('speachTranslation.manage.showNotTranslated'),
      onAction: _cache[0] || (_cache[0] = $event => {
        _ctx.statusFilter = 'incomplete';
        _ctx.applyFilters();
      })
    }, null, 8, ["label"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('speachTranslation.manage.filterTranslation')), 1), _createVNode(_component_w_input, {
      modelValue: _ctx.searchQuery,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.searchQuery = $event),
      placeholder: _ctx.$t('speachTranslation.manage.searchPlaceholder'),
      clearable: "",
      onInput: _ctx.applyFilters
    }, {
      prefix: _withCtx(() => [_createVNode(_component_icon, {
        icon: "magnify",
        class: "iconMagnify"
      })]),
      _: 1
    }, 8, ["modelValue", "placeholder", "onInput"])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('speachTranslation.manage.filterType')), 1), _createVNode(_component_w_select, {
      options: _ctx.typeOptions,
      modelValue: _ctx.typeFilter,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.typeFilter = $event),
      "value-key": "value",
      "label-key": "label",
      onChange: _ctx.applyFilters
    }, null, 8, ["options", "modelValue", "onChange"])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('speachTranslation.manage.filterStatus')), 1), _createVNode(_component_w_select, {
      options: _ctx.statusOptions,
      modelValue: _ctx.statusFilter,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.statusFilter = $event),
      "value-key": "value",
      "label-key": "label",
      onChange: _ctx.applyFilters
    }, null, 8, ["options", "modelValue", "onChange"])])])])]), !_ctx.loading ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('speachTranslation.manage.translationsCount', _ctx.filteredCount)), 1), _createElementVNode("div", _hoisted_21, [_ctx.hasMissingTranslations ? (_openBlock(), _createBlock(_component_standard_button, {
      key: 0,
      class: "translateMissingBtn",
      outlined: true,
      loading: _ctx.translatingMissing,
      disabled: _ctx.translatingMissing,
      onAction: _ctx.translateMissingForView
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        icon: "translate",
        class: "btnLeftIcon"
      }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('speachTranslation.manage.translateMissing')), 1)]),
      _: 1
    }, 8, ["loading", "disabled", "onAction"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_22, [_createVNode(_component_w_select, {
      options: _ctx.languageSelectorOptions,
      modelValue: _ctx.selectedLanguageView,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.selectedLanguageView = $event),
      "value-key": "value",
      "label-key": "label",
      onChange: _ctx.onLanguageViewChange
    }, null, 8, ["options", "modelValue", "onChange"])])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_23, [!_ctx.loading ? (_openBlock(), _createElementBlock("div", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accordionsForRender, accordion => {
      return _openBlock(), _createElementBlock("div", {
        key: accordion.parentKey,
        class: _normalizeClass(["accordionGroup", 'parent-' + accordion.parentType])
      }, [_createElementVNode("div", {
        class: _normalizeClass(["accordionHeader", {
          collapsible: _ctx.isParentCollapsible(accordion.parentKey)
        }]),
        onClick: $event => _ctx.toggleParent(accordion.parentKey)
      }, [_ctx.isParentCollapsible(accordion.parentKey) ? (_openBlock(), _createBlock(_component_icon, {
        key: 0,
        icon: _ctx.isParentExpanded(accordion.parentKey) ? 'chevron-down' : 'chevron-right',
        class: "accordionChevron"
      }, null, 8, ["icon"])) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_26, _toDisplayString(accordion.parentLabel), 1), _createElementVNode("span", _hoisted_27, _toDisplayString(accordion.count), 1), accordion.donePercent < 100 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t('speachTranslation.manage.missingCount', {
        n: accordion.missing
      })), 1), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", {
        class: "accordionProgressFill",
        style: _normalizeStyle({
          width: accordion.donePercent + '%'
        })
      }, null, 4)]), _createElementVNode("span", _hoisted_30, _toDisplayString(accordion.donePercent) + "%", 1)], 64)) : (_openBlock(), _createBlock(_component_icon, {
        key: 2,
        icon: "check-circle",
        class: "accordionDoneIcon"
      }))], 10, _hoisted_25), _withDirectives(_createElementVNode("div", _hoisted_31, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accordion.groups, (group, groupKey, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: groupKey,
          class: "translationGroup"
        }, [_createElementVNode("div", _hoisted_32, [_createElementVNode("span", _hoisted_33, _toDisplayString(index + 1), 1), _createElementVNode("span", _hoisted_34, [_createVNode(_component_icon, {
          icon: _ctx.getGroupIcon(groupKey),
          class: "groupIcon"
        }, null, 8, ["icon"]), _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.getGroupLabel(groupKey)), 1)])]), _createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.labelFor(_ctx.originalLang)) + " (" + _toDisplayString(_ctx.$t('speachTranslation.manage.defaultLabel')) + ")", 1), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [group.type === 'image' ? (_openBlock(), _createElementBlock("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createElementVNode("img", {
          src: _ctx.getImageUrl(group.sourceValue, group.videoId),
          alt: "Original image"
        }, null, 8, _hoisted_43)])])) : group.type === 'file' || group.type === 'synchro' ? (_openBlock(), _createElementBlock("div", _hoisted_44, [group.sourceValue ? (_openBlock(), _createBlock(_component_standard_button, {
          key: 0,
          outlined: true,
          class: "filePreviewBtn",
          onAction: $event => _ctx.openPdfPreview(group.sourceValue)
        }, {
          default: _withCtx(() => [_createVNode(_component_icon, {
            icon: "eye-outline",
            class: "btnLeftIcon"
          }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('speachTranslation.manage.viewPdf')), 1)]),
          _: 1
        }, 8, ["onAction"])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "sourceText",
          innerHTML: group.sourceValue
        }, null, 8, _hoisted_45))])])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getVisibleLanguages(), lang => {
          return _openBlock(), _createElementBlock("div", {
            key: lang,
            class: "langRow"
          }, [_createElementVNode("div", {
            class: _normalizeClass(["langLabel", {
              missing: _ctx.isMissing(lang, groupKey, group)
            }])
          }, _toDisplayString(_ctx.labelFor(lang)), 3), _createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [!group.isWeet && group.type !== 'image' && group.type !== 'file' && group.type !== 'synchro' && _ctx.isRichKey(groupKey) ? (_openBlock(), _createElementBlock("div", _hoisted_48, [_createElementVNode("div", {
            class: _normalizeClass(["richKeyPreview", {
              missing: !_ctx.allTranslations.speach.translations[_ctx.getTranslationKey(lang, groupKey)]
            }])
          }, [_ctx.allTranslations.speach.translations[_ctx.getTranslationKey(lang, groupKey)] ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(_ctx.stripHtmlPreview(_ctx.allTranslations.speach.translations[_ctx.getTranslationKey(lang, groupKey)])), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(_ctx.$t('speachTranslation.manage.noContent')), 1))], 2), _createVNode(_component_standard_button, {
            outlined: true,
            label: _ctx.$t('speachTranslation.manage.editHtml'),
            class: "richKeyEditBtn",
            onAction: $event => _ctx.openRichEditor(lang, groupKey, group)
          }, null, 8, ["label", "onAction"]), _ctx.cellTranslatingKey === _ctx.getTranslationKey(lang, groupKey) || _ctx.inFlightSaves.has(_ctx.getTranslationKey(lang, groupKey)) ? (_openBlock(), _createElementBlock("div", _hoisted_51, [_createVNode(_component_loader, {
            "spinner-size": "spinnersSmall"
          })])) : (_openBlock(), _createBlock(_component_icon_button, {
            key: 1,
            icon: "creation",
            tooltip: _ctx.$t('speachTranslation.manage.translateThisCell'),
            "tooltip-position": "left",
            disabled: _ctx.cellTranslatingKey !== null || _ctx.translatingMissing,
            "class-name": "aiCellBtn",
            onClick: $event => _ctx.onCellAiClick(lang, groupKey, group)
          }, null, 8, ["tooltip", "disabled", "onClick"]))])) : !group.isWeet && group.type !== 'image' && group.type !== 'file' && group.type !== 'synchro' ? (_openBlock(), _createElementBlock("div", _hoisted_52, [_withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": $event => _ctx.allTranslations.speach.translations[_ctx.getTranslationKey(lang, groupKey)] = $event,
            class: _normalizeClass(["translationInput", {
              missing: !_ctx.allTranslations.speach.translations[_ctx.getTranslationKey(lang, groupKey)]
            }]),
            spellcheck: "false",
            rows: "1",
            onBlur: $event => _ctx.onCellBlur(lang, groupKey, false)
          }, null, 42, _hoisted_53), [[_vModelText, _ctx.allTranslations.speach.translations[_ctx.getTranslationKey(lang, groupKey)]]]), _ctx.cellTranslatingKey === _ctx.getTranslationKey(lang, groupKey) || _ctx.inFlightSaves.has(_ctx.getTranslationKey(lang, groupKey)) ? (_openBlock(), _createElementBlock("div", _hoisted_54, [_createVNode(_component_loader, {
            "spinner-size": "spinnersSmall"
          })])) : (_openBlock(), _createBlock(_component_icon_button, {
            key: 1,
            icon: "creation",
            tooltip: _ctx.$t('speachTranslation.manage.translateThisCell'),
            "tooltip-position": "left",
            disabled: _ctx.cellTranslatingKey !== null || _ctx.translatingMissing,
            "class-name": "aiCellBtn",
            onClick: $event => _ctx.onCellAiClick(lang, groupKey, group)
          }, null, 8, ["tooltip", "disabled", "onClick"]))])) : group.type === 'image' ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["imageUploadContainer", {
              dragOver: _ctx.isDragOverCell(lang, groupKey)
            }]),
            onDragenter: _withModifiers($event => _ctx.onFileDragEnter(lang, groupKey), ["prevent"]),
            onDragover: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
            onDragleave: _cache[6] || (_cache[6] = _withModifiers(
            //@ts-ignore
            (...args) => _ctx.onFileDragLeave && _ctx.onFileDragLeave(...args), ["prevent"])),
            onDrop: _withModifiers($event => _ctx.onFileDrop($event, lang, groupKey, group), ["prevent"])
          }, [!group.isWeet ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_ctx.allTranslations.speach.translations[_ctx.getTranslationKey(lang, groupKey)] ? (_openBlock(), _createElementBlock("div", _hoisted_56, [_createElementVNode("img", {
            src: _ctx.getImageUrl(_ctx.allTranslations.speach.translations[_ctx.getTranslationKey(lang, groupKey)]),
            alt: "Translated image"
          }, null, 8, _hoisted_57)])) : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "imagePlaceholder",
            onClick: $event => _ctx.triggerUpload(lang, groupKey)
          }, [_createVNode(_component_icon, {
            icon: "cloud-upload-outline",
            class: "filePlaceholderIcon"
          }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('speachTranslation.manage.dropOrUploadImage')), 1)], 8, _hoisted_58))], 64)) : group.videoId && _ctx.allTranslations.weet[group.videoId] ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_ctx.allTranslations.weet[group.videoId].translations[_ctx.getWeetTranslationKey(_ctx.allTranslations.weet[group.videoId].translations, lang, _ctx.getOriginalWeetKey(groupKey))] ? (_openBlock(), _createElementBlock("div", _hoisted_59, [_createElementVNode("img", {
            src: _ctx.getImageUrl(_ctx.allTranslations.weet[group.videoId].translations[_ctx.getWeetTranslationKey(_ctx.allTranslations.weet[group.videoId].translations, lang, _ctx.getOriginalWeetKey(groupKey))], group.videoId),
            alt: "Translated image"
          }, null, 8, _hoisted_60)])) : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "imagePlaceholder",
            onClick: $event => _ctx.triggerUpload(lang, groupKey)
          }, [_createVNode(_component_icon, {
            icon: "cloud-upload-outline",
            class: "filePlaceholderIcon"
          }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('speachTranslation.manage.dropOrUploadImage')), 1)], 8, _hoisted_61))], 64)) : _createCommentVNode("", true), _createElementVNode("input", {
            type: "file",
            id: `file-${lang}-${groupKey}`,
            hidden: "",
            accept: "image/*",
            onChange: e => _ctx.onFileChange(e, lang, groupKey, group)
          }, null, 40, _hoisted_62), _createVNode(_component_standard_button, {
            class: "uploadBtn",
            outlined: true,
            label: _ctx.$t('speachTranslation.manage.uploadImage'),
            onAction: $event => _ctx.triggerUpload(lang, groupKey)
          }, null, 8, ["label", "onAction"])], 42, _hoisted_55)) : group.type === 'file' || group.type === 'synchro' ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: _normalizeClass(["imageUploadContainer fileUploadContainer", {
              dragOver: _ctx.isDragOverCell(lang, groupKey)
            }]),
            onDragenter: _withModifiers($event => _ctx.onFileDragEnter(lang, groupKey), ["prevent"]),
            onDragover: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"])),
            onDragleave: _cache[8] || (_cache[8] = _withModifiers(
            //@ts-ignore
            (...args) => _ctx.onFileDragLeave && _ctx.onFileDragLeave(...args), ["prevent"])),
            onDrop: _withModifiers($event => _ctx.onFileDrop($event, lang, groupKey, group), ["prevent"])
          }, [_ctx.allTranslations.speach.translations[_ctx.getTranslationKey(lang, groupKey)] ? (_openBlock(), _createBlock(_component_standard_button, {
            key: 0,
            outlined: true,
            class: "filePreviewBtn",
            onAction: $event => _ctx.openPdfPreview(_ctx.allTranslations.speach.translations[_ctx.getTranslationKey(lang, groupKey)])
          }, {
            default: _withCtx(() => [_createVNode(_component_icon, {
              icon: "eye-outline",
              class: "btnLeftIcon"
            }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('speachTranslation.manage.viewPdf')), 1)]),
            _: 1
          }, 8, ["onAction"])) : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "filePlaceholder",
            onClick: $event => _ctx.triggerUpload(lang, groupKey)
          }, [_createVNode(_component_icon, {
            icon: "cloud-upload-outline",
            class: "filePlaceholderIcon"
          }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('speachTranslation.manage.dropOrUploadFile')), 1)], 8, _hoisted_64)), _createElementVNode("input", {
            type: "file",
            id: `file-${lang}-${groupKey}`,
            hidden: "",
            onChange: e => _ctx.onFileChange(e, lang, groupKey, group)
          }, null, 40, _hoisted_65), _createVNode(_component_standard_button, {
            outlined: true,
            label: _ctx.$t('speachTranslation.manage.uploadFile'),
            onAction: $event => _ctx.triggerUpload(lang, groupKey)
          }, null, 8, ["label", "onAction"])], 42, _hoisted_63)) : group.isWeet && group.videoId && _ctx.allTranslations.weet[group.videoId] ? (_openBlock(), _createElementBlock("div", _hoisted_66, [_withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": $event => _ctx.allTranslations.weet[group.videoId].translations[_ctx.getWeetTranslationKey(_ctx.allTranslations.weet[group.videoId].translations, lang, _ctx.getOriginalWeetKey(groupKey))] = $event,
            class: _normalizeClass(["translationInput", {
              missing: !_ctx.allTranslations.weet[group.videoId].translations[_ctx.getWeetTranslationKey(_ctx.allTranslations.weet[group.videoId].translations, lang, _ctx.getOriginalWeetKey(groupKey))]
            }]),
            spellcheck: "false",
            rows: "1",
            onBlur: $event => _ctx.onCellBlur(lang, groupKey, true, group.videoId)
          }, null, 42, _hoisted_67), [[_vModelText, _ctx.allTranslations.weet[group.videoId].translations[_ctx.getWeetTranslationKey(_ctx.allTranslations.weet[group.videoId].translations, lang, _ctx.getOriginalWeetKey(groupKey))]]]), _ctx.cellTranslatingKey === 'weet:' + group.videoId + ':' + lang + ':' + groupKey || _ctx.inFlightSaves.has('weet:' + group.videoId + ':' + _ctx.getWeetTranslationKey(_ctx.allTranslations.weet[group.videoId].translations, lang, _ctx.getOriginalWeetKey(groupKey))) ? (_openBlock(), _createElementBlock("div", _hoisted_68, [_createVNode(_component_loader, {
            "spinner-size": "spinnersSmall"
          })])) : (_openBlock(), _createBlock(_component_icon_button, {
            key: 1,
            icon: "creation",
            tooltip: _ctx.$t('speachTranslation.manage.translateThisCell'),
            "tooltip-position": "left",
            disabled: _ctx.cellTranslatingKey !== null || _ctx.translatingMissing,
            "class-name": "aiCellBtn",
            onClick: $event => _ctx.onCellAiClick(lang, groupKey, group)
          }, null, 8, ["tooltip", "disabled", "onClick"]))])) : _createCommentVNode("", true)])])]);
        }), 128))])]);
      }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accordion.subAccordions || [], subAcc => {
        return _openBlock(), _createElementBlock("div", {
          key: subAcc.parentKey,
          class: "accordionGroup parent-chapter subAccordion"
        }, [_createElementVNode("div", {
          class: "accordionHeader collapsible",
          onClick: $event => _ctx.toggleParent(subAcc.parentKey)
        }, [_createVNode(_component_icon, {
          icon: _ctx.isParentExpanded(subAcc.parentKey) ? 'chevron-down' : 'chevron-right',
          class: "accordionChevron"
        }, null, 8, ["icon"]), _createElementVNode("span", _hoisted_70, _toDisplayString(subAcc.parentLabel), 1), _ctx.canManageSubtitlesForChapter(subAcc.parentKey) ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "manageSubtitleBtnWrapper",
          onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
        }, [_createVNode(_component_standard_button, {
          outlined: true,
          class: "manageSubtitleBtn",
          loading: _ctx.openingSubtitleForChapter === subAcc.parentKey,
          disabled: _ctx.openingSubtitleForChapter !== null,
          onAction: $event => _ctx.openSubtitleDialog(subAcc.parentKey)
        }, {
          default: _withCtx(() => [_createVNode(_component_icon, {
            icon: "subtitles-outline",
            class: "btnLeftIcon"
          }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('speachTranslation.manage.manageSubtitle')), 1)]),
          _: 1
        }, 8, ["loading", "disabled", "onAction"])])) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_71, _toDisplayString(subAcc.count), 1), subAcc.donePercent < 100 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.$t('speachTranslation.manage.missingCount', {
          n: subAcc.missing
        })), 1), _createElementVNode("div", _hoisted_73, [_createElementVNode("div", {
          class: "accordionProgressFill",
          style: _normalizeStyle({
            width: subAcc.donePercent + '%'
          })
        }, null, 4)]), _createElementVNode("span", _hoisted_74, _toDisplayString(subAcc.donePercent) + "%", 1)], 64)) : (_openBlock(), _createBlock(_component_icon, {
          key: 2,
          icon: "check-circle",
          class: "accordionDoneIcon"
        }))], 8, _hoisted_69), _withDirectives(_createElementVNode("div", _hoisted_75, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subAcc.groups, (group, groupKey, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: groupKey,
            class: "translationGroup"
          }, [_createElementVNode("div", _hoisted_76, [_createElementVNode("span", _hoisted_77, _toDisplayString(index + 1), 1), _createElementVNode("span", _hoisted_78, [_createVNode(_component_icon, {
            icon: _ctx.getGroupIcon(groupKey),
            class: "groupIcon"
          }, null, 8, ["icon"]), _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.getGroupLabel(groupKey)), 1)])]), _createElementVNode("div", _hoisted_80, [_createElementVNode("div", _hoisted_81, [_createElementVNode("div", _hoisted_82, _toDisplayString(_ctx.labelFor(_ctx.originalLang)) + " (" + _toDisplayString(_ctx.$t('speachTranslation.manage.defaultLabel')) + ")", 1), _createElementVNode("div", _hoisted_83, [_createElementVNode("div", _hoisted_84, [group.type === 'image' ? (_openBlock(), _createElementBlock("div", _hoisted_85, [_createElementVNode("div", _hoisted_86, [_createElementVNode("img", {
            src: _ctx.getImageUrl(group.sourceValue, group.videoId),
            alt: "Original image"
          }, null, 8, _hoisted_87)])])) : group.type === 'file' || group.type === 'synchro' ? (_openBlock(), _createElementBlock("div", _hoisted_88, [group.sourceValue ? (_openBlock(), _createBlock(_component_standard_button, {
            key: 0,
            outlined: true,
            class: "filePreviewBtn",
            onAction: $event => _ctx.openPdfPreview(group.sourceValue)
          }, {
            default: _withCtx(() => [_createVNode(_component_icon, {
              icon: "eye-outline",
              class: "btnLeftIcon"
            }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('speachTranslation.manage.viewPdf')), 1)]),
            _: 1
          }, 8, ["onAction"])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "sourceText",
            innerHTML: group.sourceValue
          }, null, 8, _hoisted_89))])])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getVisibleLanguages(), lang => {
            return _openBlock(), _createElementBlock("div", {
              key: lang,
              class: "langRow"
            }, [_createElementVNode("div", {
              class: _normalizeClass(["langLabel", {
                missing: _ctx.isMissing(lang, groupKey, group)
              }])
            }, _toDisplayString(_ctx.labelFor(lang)), 3), _createElementVNode("div", _hoisted_90, [_createElementVNode("div", _hoisted_91, [!group.isWeet && group.type !== 'image' && group.type !== 'file' && group.type !== 'synchro' && _ctx.isRichKey(groupKey) ? (_openBlock(), _createElementBlock("div", _hoisted_92, [_createElementVNode("div", {
              class: _normalizeClass(["richKeyPreview", {
                missing: !_ctx.allTranslations.speach.translations[_ctx.getTranslationKey(lang, groupKey)]
              }])
            }, [_ctx.allTranslations.speach.translations[_ctx.getTranslationKey(lang, groupKey)] ? (_openBlock(), _createElementBlock("span", _hoisted_93, _toDisplayString(_ctx.stripHtmlPreview(_ctx.allTranslations.speach.translations[_ctx.getTranslationKey(lang, groupKey)])), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_94, _toDisplayString(_ctx.$t('speachTranslation.manage.noContent')), 1))], 2), _createVNode(_component_standard_button, {
              outlined: true,
              label: _ctx.$t('speachTranslation.manage.editHtml'),
              class: "richKeyEditBtn",
              onAction: $event => _ctx.openRichEditor(lang, groupKey, group)
            }, null, 8, ["label", "onAction"]), _ctx.cellTranslatingKey === _ctx.getTranslationKey(lang, groupKey) || _ctx.inFlightSaves.has(_ctx.getTranslationKey(lang, groupKey)) ? (_openBlock(), _createElementBlock("div", _hoisted_95, [_createVNode(_component_loader, {
              "spinner-size": "spinnersSmall"
            })])) : (_openBlock(), _createBlock(_component_icon_button, {
              key: 1,
              icon: "creation",
              tooltip: _ctx.$t('speachTranslation.manage.translateThisCell'),
              "tooltip-position": "left",
              disabled: _ctx.cellTranslatingKey !== null || _ctx.translatingMissing,
              "class-name": "aiCellBtn",
              onClick: $event => _ctx.onCellAiClick(lang, groupKey, group)
            }, null, 8, ["tooltip", "disabled", "onClick"]))])) : !group.isWeet && group.type !== 'image' && group.type !== 'file' && group.type !== 'synchro' ? (_openBlock(), _createElementBlock("div", _hoisted_96, [_withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": $event => _ctx.allTranslations.speach.translations[_ctx.getTranslationKey(lang, groupKey)] = $event,
              class: _normalizeClass(["translationInput", {
                missing: !_ctx.allTranslations.speach.translations[_ctx.getTranslationKey(lang, groupKey)]
              }]),
              spellcheck: "false",
              rows: "1",
              onBlur: $event => _ctx.onCellBlur(lang, groupKey, false)
            }, null, 42, _hoisted_97), [[_vModelText, _ctx.allTranslations.speach.translations[_ctx.getTranslationKey(lang, groupKey)]]]), _ctx.cellTranslatingKey === _ctx.getTranslationKey(lang, groupKey) || _ctx.inFlightSaves.has(_ctx.getTranslationKey(lang, groupKey)) ? (_openBlock(), _createElementBlock("div", _hoisted_98, [_createVNode(_component_loader, {
              "spinner-size": "spinnersSmall"
            })])) : (_openBlock(), _createBlock(_component_icon_button, {
              key: 1,
              icon: "creation",
              tooltip: _ctx.$t('speachTranslation.manage.translateThisCell'),
              "tooltip-position": "left",
              disabled: _ctx.cellTranslatingKey !== null || _ctx.translatingMissing,
              "class-name": "aiCellBtn",
              onClick: $event => _ctx.onCellAiClick(lang, groupKey, group)
            }, null, 8, ["tooltip", "disabled", "onClick"]))])) : group.type === 'image' ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["imageUploadContainer", {
                dragOver: _ctx.isDragOverCell(lang, groupKey)
              }]),
              onDragenter: _withModifiers($event => _ctx.onFileDragEnter(lang, groupKey), ["prevent"]),
              onDragover: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["prevent"])),
              onDragleave: _cache[11] || (_cache[11] = _withModifiers(
              //@ts-ignore
              (...args) => _ctx.onFileDragLeave && _ctx.onFileDragLeave(...args), ["prevent"])),
              onDrop: _withModifiers($event => _ctx.onFileDrop($event, lang, groupKey, group), ["prevent"])
            }, [!group.isWeet ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_ctx.allTranslations.speach.translations[_ctx.getTranslationKey(lang, groupKey)] ? (_openBlock(), _createElementBlock("div", _hoisted_100, [_createElementVNode("img", {
              src: _ctx.getImageUrl(_ctx.allTranslations.speach.translations[_ctx.getTranslationKey(lang, groupKey)]),
              alt: "Translated image"
            }, null, 8, _hoisted_101)])) : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "imagePlaceholder",
              onClick: $event => _ctx.triggerUpload(lang, groupKey)
            }, [_createVNode(_component_icon, {
              icon: "cloud-upload-outline",
              class: "filePlaceholderIcon"
            }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('speachTranslation.manage.dropOrUploadImage')), 1)], 8, _hoisted_102))], 64)) : group.videoId && _ctx.allTranslations.weet[group.videoId] ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 1
            }, [_ctx.allTranslations.weet[group.videoId].translations[_ctx.getWeetTranslationKey(_ctx.allTranslations.weet[group.videoId].translations, lang, _ctx.getOriginalWeetKey(groupKey))] ? (_openBlock(), _createElementBlock("div", _hoisted_103, [_createElementVNode("img", {
              src: _ctx.getImageUrl(_ctx.allTranslations.weet[group.videoId].translations[_ctx.getWeetTranslationKey(_ctx.allTranslations.weet[group.videoId].translations, lang, _ctx.getOriginalWeetKey(groupKey))], group.videoId),
              alt: "Translated image"
            }, null, 8, _hoisted_104)])) : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "imagePlaceholder",
              onClick: $event => _ctx.triggerUpload(lang, groupKey)
            }, [_createVNode(_component_icon, {
              icon: "cloud-upload-outline",
              class: "filePlaceholderIcon"
            }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('speachTranslation.manage.dropOrUploadImage')), 1)], 8, _hoisted_105))], 64)) : _createCommentVNode("", true), _createElementVNode("input", {
              type: "file",
              id: `file-${lang}-${groupKey}`,
              hidden: "",
              accept: "image/*",
              onChange: e => _ctx.onFileChange(e, lang, groupKey, group)
            }, null, 40, _hoisted_106), _createVNode(_component_standard_button, {
              class: "uploadBtn",
              outlined: true,
              label: _ctx.$t('speachTranslation.manage.uploadImage'),
              onAction: $event => _ctx.triggerUpload(lang, groupKey)
            }, null, 8, ["label", "onAction"])], 42, _hoisted_99)) : group.type === 'file' || group.type === 'synchro' ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: _normalizeClass(["imageUploadContainer fileUploadContainer", {
                dragOver: _ctx.isDragOverCell(lang, groupKey)
              }]),
              onDragenter: _withModifiers($event => _ctx.onFileDragEnter(lang, groupKey), ["prevent"]),
              onDragover: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["prevent"])),
              onDragleave: _cache[13] || (_cache[13] = _withModifiers(
              //@ts-ignore
              (...args) => _ctx.onFileDragLeave && _ctx.onFileDragLeave(...args), ["prevent"])),
              onDrop: _withModifiers($event => _ctx.onFileDrop($event, lang, groupKey, group), ["prevent"])
            }, [_ctx.allTranslations.speach.translations[_ctx.getTranslationKey(lang, groupKey)] ? (_openBlock(), _createBlock(_component_standard_button, {
              key: 0,
              outlined: true,
              class: "filePreviewBtn",
              onAction: $event => _ctx.openPdfPreview(_ctx.allTranslations.speach.translations[_ctx.getTranslationKey(lang, groupKey)])
            }, {
              default: _withCtx(() => [_createVNode(_component_icon, {
                icon: "eye-outline",
                class: "btnLeftIcon"
              }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('speachTranslation.manage.viewPdf')), 1)]),
              _: 1
            }, 8, ["onAction"])) : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "filePlaceholder",
              onClick: $event => _ctx.triggerUpload(lang, groupKey)
            }, [_createVNode(_component_icon, {
              icon: "cloud-upload-outline",
              class: "filePlaceholderIcon"
            }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('speachTranslation.manage.dropOrUploadFile')), 1)], 8, _hoisted_108)), _createElementVNode("input", {
              type: "file",
              id: `file-${lang}-${groupKey}`,
              hidden: "",
              onChange: e => _ctx.onFileChange(e, lang, groupKey, group)
            }, null, 40, _hoisted_109), _createVNode(_component_standard_button, {
              outlined: true,
              label: _ctx.$t('speachTranslation.manage.uploadFile'),
              onAction: $event => _ctx.triggerUpload(lang, groupKey)
            }, null, 8, ["label", "onAction"])], 42, _hoisted_107)) : group.isWeet && group.videoId && _ctx.allTranslations.weet[group.videoId] ? (_openBlock(), _createElementBlock("div", _hoisted_110, [_withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": $event => _ctx.allTranslations.weet[group.videoId].translations[_ctx.getWeetTranslationKey(_ctx.allTranslations.weet[group.videoId].translations, lang, _ctx.getOriginalWeetKey(groupKey))] = $event,
              class: _normalizeClass(["translationInput", {
                missing: !_ctx.allTranslations.weet[group.videoId].translations[_ctx.getWeetTranslationKey(_ctx.allTranslations.weet[group.videoId].translations, lang, _ctx.getOriginalWeetKey(groupKey))]
              }]),
              spellcheck: "false",
              rows: "1",
              onBlur: $event => _ctx.onCellBlur(lang, groupKey, true, group.videoId)
            }, null, 42, _hoisted_111), [[_vModelText, _ctx.allTranslations.weet[group.videoId].translations[_ctx.getWeetTranslationKey(_ctx.allTranslations.weet[group.videoId].translations, lang, _ctx.getOriginalWeetKey(groupKey))]]]), _ctx.cellTranslatingKey === 'weet:' + group.videoId + ':' + lang + ':' + groupKey || _ctx.inFlightSaves.has('weet:' + group.videoId + ':' + _ctx.getWeetTranslationKey(_ctx.allTranslations.weet[group.videoId].translations, lang, _ctx.getOriginalWeetKey(groupKey))) ? (_openBlock(), _createElementBlock("div", _hoisted_112, [_createVNode(_component_loader, {
              "spinner-size": "spinnersSmall"
            })])) : (_openBlock(), _createBlock(_component_icon_button, {
              key: 1,
              icon: "creation",
              tooltip: _ctx.$t('speachTranslation.manage.translateThisCell'),
              "tooltip-position": "left",
              disabled: _ctx.cellTranslatingKey !== null || _ctx.translatingMissing,
              "class-name": "aiCellBtn",
              onClick: $event => _ctx.onCellAiClick(lang, groupKey, group)
            }, null, 8, ["tooltip", "disabled", "onClick"]))])) : _createCommentVNode("", true)])])]);
          }), 128))])]);
        }), 128))], 512), [[_vShow, _ctx.isParentExpanded(subAcc.parentKey)]])]);
      }), 128))], 512), [[_vShow, _ctx.isParentExpanded(accordion.parentKey)]])], 2);
    }), 128)), _ctx.filteredCount === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_113, _toDisplayString(_ctx.$t('speachTranslation.manage.noResults')), 1)) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_114, [_createVNode(_component_loader)]))]), _createElementVNode("div", _hoisted_115, [_createVNode(_component_standard_button, {
      class: "closeBtn",
      outlined: true,
      label: _ctx.$t('speachTranslation.manage.close'),
      loading: _ctx.closing,
      disabled: _ctx.closing,
      onAction: _ctx.onCloseClick
    }, null, 8, ["label", "loading", "disabled", "onAction"])])]), _ctx.overwriteDialogVisible ? (_openBlock(), _createBlock(_component_confirm_dialog, {
      key: 0,
      visible: _ctx.overwriteDialogVisible,
      title: _ctx.$t('speachTranslation.manage.overwriteDialog.title'),
      message: _ctx.$t('speachTranslation.manage.overwriteDialog.message'),
      "confirm-button-text": _ctx.$t('speachTranslation.manage.overwriteDialog.confirm'),
      "cancel-button-text": _ctx.$t('speachTranslation.manage.overwriteDialog.cancel'),
      onOnCanceled: _ctx.cancelOverwrite,
      onOnDialogClose: _ctx.cancelOverwrite,
      onOnConfirmed: _ctx.confirmOverwrite
    }, null, 8, ["visible", "title", "message", "confirm-button-text", "cancel-button-text", "onOnCanceled", "onOnDialogClose", "onOnConfirmed"])) : _createCommentVNode("", true), _ctx.htmlEditDialogVisible && _ctx.htmlEditContext ? (_openBlock(), _createBlock(_component_speach_html_translation_dialog, {
      key: 1,
      visible: _ctx.htmlEditDialogVisible,
      "t-key": _ctx.htmlEditContext.tKey,
      "source-html": _ctx.htmlEditContext.sourceValue,
      "initial-html": _ctx.allTranslations.speach.translations[_ctx.htmlEditContext.tKey] || '',
      "original-lang-label": _ctx.labelForLanguage(_ctx.originalLang),
      "target-lang-label": _ctx.labelForLanguage(_ctx.htmlEditContext.lang),
      saving: _ctx.htmlEditSaving,
      onSave: _ctx.saveHtmlEditor,
      onClose: _ctx.closeHtmlEditor
    }, null, 8, ["visible", "t-key", "source-html", "initial-html", "original-lang-label", "target-lang-label", "saving", "onSave", "onClose"])) : _createCommentVNode("", true), _ctx.diagramEditDialogVisible && _ctx.diagramEditContext ? (_openBlock(), _createBlock(_component_speach_diagram_translation_dialog, {
      key: 2,
      visible: _ctx.diagramEditDialogVisible,
      "t-key": _ctx.diagramEditContext.tKey,
      "diagram-data": {
        d2Code: _ctx.allTranslations.speach.translations[_ctx.diagramEditContext.tKey] || ''
      },
      "target-lang-label": _ctx.labelForLanguage(_ctx.diagramEditContext.lang),
      "vision-enabled": _ctx.visionEnabled,
      saving: _ctx.diagramEditSaving,
      onSave: _ctx.saveDiagramEditor,
      onCancelChanges: _ctx.closeDiagramEditor
    }, null, 8, ["visible", "t-key", "diagram-data", "target-lang-label", "vision-enabled", "saving", "onSave", "onCancelChanges"])) : _createCommentVNode("", true), _ctx.pdfPreviewVisible ? (_openBlock(), _createBlock(_component_w_pdf_viewer_dialog, {
      key: 3,
      visible: _ctx.pdfPreviewVisible,
      "pdf-url": _ctx.pdfPreviewUrl,
      onClose: _ctx.closePdfPreview
    }, null, 8, ["visible", "pdf-url", "onClose"])) : _createCommentVNode("", true), _ctx.subtitleDialogVisible ? (_openBlock(), _createBlock(_component_w_dialog, {
      key: 4,
      visible: _ctx.subtitleDialogVisible,
      fullscreen: true,
      "append-to-body": true,
      "custom-class": 'backgroundOverlayEditingWeet',
      closeOnOutsideClick: false,
      onOnDialogClose: _ctx.closeSubtitleDialog
    }, {
      default: _withCtx(() => [_ctx.subtitleDialogUrl ? (_openBlock(), _createElementBlock("iframe", {
        key: 0,
        src: _ctx.subtitleDialogUrl,
        class: "iFrameFullForSubtitle",
        allow: "fullscreen *;camera *;microphone *;display-capture *;autoplay *"
      }, null, 8, _hoisted_116)) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["visible", "onOnDialogClose"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["visible"]);
}